// src/components/YearFilterTabs.tsx

import React from 'react';

interface YearFilterTabsProps {
  years: string[];
  selectedYear: string;
  onSelectYear: (year: string) => void;
}

const YearFilterTabs: React.FC<YearFilterTabsProps> = ({ years, selectedYear, onSelectYear }) => {
  return (
    <div className="flex space-x-3 my-4">
      {years.map((year) => (
          <button
            key={year}
        className={`px-4 py-[6px] text-xs font-medium rounded-full ${
          selectedYear === year
            ? 'bg-MainColor text-white'
            : 'bg-gray-100 text-gray-600'
        }`}
  onClick={() => onSelectYear(year)}
>
  {year}
  </button>
))}
  </div>
);
};

export default YearFilterTabs;
